export const contactsData = {
    email: 'devbyashu@gmail.com',
    phone: '+918305870369',
    address: 'Pune (MH) India',

    sheetAPI: 'https://sheetdb.io/api/v1/3dbbgk57kehyz'
}